
export default class Queue {
  constructor () {
    this.items = []
  }
  enqueue (o) {
    this.items.push(o)
  }
  dequeue () {
    if (!this.items.length) {
      console.warn('no items in the queue')
      return
    }
    return this.items.shift()
  }
  peek () {
    if (!this.items.length) {
      return null
    }
    return this.items[0]
  }
}
